import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pep-questions',
  templateUrl: './pep-questions.component.html',
  styleUrls: ['./pep-questions.component.scss']
})
export class PepQuestionsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
